import { render } from "./GameContent.vue?vue&type=template&id=0e8746b8&scoped=true"
import script from "./GameContent.vue?vue&type=script&lang=js"
export * from "./GameContent.vue?vue&type=script&lang=js"

import "./GameContent.vue?vue&type=style&index=0&id=0e8746b8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8746b8"]])

export default __exports__